export default "__VITE_ASSET__CzFakCvE__"